import baseService from "../BaseService";
import mixinsMessage from "@/mixins/message";
import QhRecessoLinha from "@/model/qh/QhRecessoLinha";
import QhRecessoResumo from "@/model/qh/QhRecessoResumo";
export default {
  listarPorPlano(idPlano) {
    return baseService
      .get("/api/qh-recessos", { params: { idPlano: idPlano } })
      .then(response => {
        if (response && response.data) {
          return response.data.map(d => new QhRecessoLinha(d));
        }
        return [];
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar listar recessos", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  buscarPorId(idRecesso) {
    return baseService
      .get("/api/qh-recessos/" + idRecesso)
      .then(response => {
        if (response && response.data) {
          return new QhRecessoLinha(response.data);
        }
        return null;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar carregar recesso", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  salvar(recesso) {
    if (recesso.id) {
      return baseService
        .put("/api/qh-recessos/" + recesso.id, recesso)
        .then(response => {
          mixinsMessage.methods.success(response.data);
          return response.data;
        })
        .catch(function(error) {
          mixinsMessage.methods.error("Erro ao tentar atualizar recesso", error);
          // eslint-disable-next-line no-console
          console.error(error);
        });
    }
    return baseService
      .post("/api/qh-recessos", recesso)
      .then(response => {
        mixinsMessage.methods.success(response.data);
        return response.data;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar cadastrar recesso", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  excluir(recesso) {
    return baseService
      .delete("/api/qh-recessos/" + recesso.id)
      .then(response => {
        mixinsMessage.methods.success(response.data);
        return response.data;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar excluir recesso", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  contarPorPlano(idPlano) {
    return baseService
      .get("/api/qh-recessos/contagem", { params: { idPlano: idPlano } })
      .then(response => {
        if (response && response.data != null) {
          return response.data;
        }
        return 0;
      })
      .catch(function(error) {
        // eslint-disable-next-line no-console
        console.error(error);
        return 0;
      });
  },
  resumoPorPlano(idPlano) {
    return baseService
      .get("/api/qh-recessos/resumo", { params: { idPlano: idPlano } })
      .then(response => {
        if (response && response.data) {
          return response.data.map(d => new QhRecessoResumo(d));
        }
        return [];
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar carregar resumo", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  listarTiposFuncao() {
    return baseService
      .get("/api/qh-recessos/tipos-funcao")
      .then(response => {
        if (response && response.data) {
          return response.data;
        }
        return [];
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar listar funções", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  }
};
